/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-06 14:27:01
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-02-16 17:32:43
 */

import request from "../../utils/request";
import server from "./config";
export default {
    /**
     * 获取咨询详情
     */
    getConsultDetail: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/getDetailForPatient`,
            method: "post",
            data
        });
    },
    /**
     * 获取当前值班医生（复购流程：点击「复购」时调用）
     * @returns { doctorId: 医生ID, doctorName: 医生姓名 }
     */
    onDutyDoctor: () => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/onDutyDoctor`,
            method: "get"
        });
    },
    /**
     * 患者端根据历史处方发起复购（选「一致」时调用）
     * @param {Object} data - { sourcePrescriptionId: 历史处方ID }
     * @returns { consultRecordId: 新问诊ID, prescriptionId: 新处方ID, serviceAggRecordId: 新服务包记录ID(普通处方为空), sourcePrescriptionId }
     */
    repurchaseV2: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/repurchase`,
            method: "post",
            data
        });
    },
    /**
     * 创建咨询记录
     */
    saveConsult: data => {
        let newData = {...data}
        if([process.env.huyouxiangban_APPID,process.env.yangzijiang_APPID].indexOf(sessionStorage.getItem('appid')) > -1){
            newData['enableOnDuty'] = true
        }
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/toConsult`,
            method: "post",
            data:newData
        });
    },
    /**
     * 获取咨询就诊人列表
     */
    getConsultMemberList: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/getConsultMemberLIst`,
            method: "post",
            data
        });
    },
    /**
     * 获取咨询列表
     */
    getConsultPage: (data, noToast = false) => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/getConsultPage`,
            method: "post",
            data,
            noToast
        });
    },
    /**
     * 获取历史咨询记录
     */
    getImRecordPage: params => {
        return request({
            url: `${process.env.IM_API_URL}/getImRecordPage`,
            method: "get",
            params
        });
    },
    /**
     * 获取咨询下是否有可用服务包
     */
    serviceRecordListForChoose: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/serviceRecordListForChoose`,
            method: "post",
            data
        });
    },
    /**
     * 获取资讯是否写了评论
     */
    isComment: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/record/comment/1/is-comment`,
            method: "post",
            params: data
        });
    },
    /**
     * 查看医生的评论
     */
    doctorComment: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/record/comment/1/get`,
            method: "post",
            data
        });
    },
    /**
     * 创建评论
     */
    createComment: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/record/comment/1/create`,
            method: "post",
            data
        });
    },
    /**
     * 获取评论标签
     */
    commentTags: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/record/comment/{version}/comment/star/prompt`,
            method: "post",
            data
        });
    },
    // 结束问诊
    transferAfterCancelCurrent: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/patient/consult/1/transferAfterCancelCurrent`,
            method: "post",
            data
        });
    },
    
};



// WEBPACK FOOTER //
// ./src/api/modules/consult.js